<template>
  <div class="app-empty-state">
    <v-icon size="56" color="primary">{{ icon }}</v-icon>
    <div class="text-subtitle-1 font-weight-bold mt-3">{{ title }}</div>
    <div class="text-body-2 mt-1" style="opacity: 0.6">{{ message }}</div>
    <v-btn
      v-if="actionText"
      color="primary"
      rounded
      class="mt-5"
      @click="$emit('action')"
    >
      {{ actionText }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "AppEmptyState",
  props: {
    icon: { type: String, default: "mdi-package-variant" },
    title: { type: String, default: "Nothing here yet" },
    message: { type: String, default: "" },
    actionText: { type: String, default: "" },
  },
};
</script>
